var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    fill: "#DCDCDC",
    stroke: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1836_116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 52,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 27C53 41.3594 41.3594 53 27 53C12.6406 53 1 41.3594 1 27C1 12.6406 12.6406 1 27 1C41.3594 1 53 12.6406 53 27Z",
    fill: "#DCDCDC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1836_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1406 32.6016C33.0044 32.6016 37.7578 27.8481 37.7578 21.9844C37.7578 16.1207 33.0044 11.3672 27.1406 11.3672C21.2769 11.3672 16.5235 16.1207 16.5235 21.9844C16.5235 27.8481 21.2769 32.6016 27.1406 32.6016Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6289 46.0313C40.7813 39.4922 34.3477 35.2383 27.1758 35.2383C20.0039 35.2383 13.5352 39.4571 10.7227 46.0313C10.336 46.9102 10.7227 47.8946 11.6016 48.2813C11.7071 48.3516 11.8477 48.3868 11.9531 48.3868V48.4219H42.0469C42.293 48.4219 42.5391 48.3868 42.75 48.2813C43.5938 47.8946 44.0156 46.9102 43.6289 46.0313Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6289 47.6289C40.7813 54.168 34.3477 58.4219 27.1758 58.4219C20.0039 58.4219 13.5352 54.2031 10.7227 47.6289C10.336 46.75 10.7227 45.7656 11.6016 45.3789C11.7071 45.3086 11.8477 45.2734 11.9532 45.2734V45.2383H42.0469C42.293 45.2383 42.5391 45.2734 42.75 45.3789C43.5938 45.7656 44.0157 46.75 43.6289 47.6289Z",
    fill: "#A4A4A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicPlaceholder);
export default __webpack_public_path__ + "static/media/profile-pic-placeholder.17273e310cc11002059dff46aec8e292.svg";
export { ForwardRef as ReactComponent };